import notesModule from "../notes.store";
import * as getters from "./getters.context.store";
import * as mutations from "./mutations.context.store";
import * as actions from "./actions.context.store";

export default (moduleName, ref, group_id) => ({
  namespaced: true,
  state() {
    return {
      moduleName,
      ref_path: ref.path,
      group_id,
      rating_date: "",
      goal_deadline: "",
      template_ref: {},
      items: {},
      document_listener: null,
      items_listener: null,
      lastFetched: "never"
    }
  },
  getters,
  mutations,
  actions,
  modules: {
    notes: notesModule("notes", moduleName, ref.parent.parent.collection("notes")),
  }
});